import { useTranslation } from "react-i18next";
import GenericComponent from "../../../utils/genericComponent/GenericComponent";
import { ReactComponent as Image } from "../../../../assets/img/mail-illustration.svg";
import { redirect } from "../../../../utils/reformat";
import i18n from "../../../../i18n";

const FailureVideoId = () => {
  const { t } = useTranslation();

  return (
    <GenericComponent
      ImageSrc={Image}
      transComponent={{ br: <br />, b: <b>{}</b> }}
      pageTitle={t`screens.errors.failureVideoId.title`}
      pageSubtitle={"screens.errors.failureVideoId.subtitle"}
      buttonLabel={t`screens.common.backHome`}
      onClickCallback={() => {
        postMessage("error");
        redirect(`https://www.corner.ch/${i18n.resolvedLanguage}`);
      }}
    />
  );
};

export default FailureVideoId;
